import styled from 'styled-components/native';

export default styled.View.attrs({ pointerEvents: 'box-none' })`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
